if (!customElements.get('studio-gallery')) {
  customElements.define('studio-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const rail = this.querySelector('.pd-thumbnails');
      const next = this.querySelector('[data-thumbs-next]');
      const sync = () => { if (next && rail) { next.hidden = rail.scrollHeight <= rail.clientHeight + 2; next.disabled = rail.scrollTop + rail.clientHeight >= rail.scrollHeight - 2; } };
      this.railObserver = new ResizeObserver(sync);
      if (rail) { this.railObserver.observe(rail); rail.addEventListener('scroll', sync, {passive:true}); }
      next?.addEventListener('click', () => rail.scrollBy({top:124,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'}));
      sync();
      this.syncPlayback = () => {
        this.querySelectorAll('.pd-media').forEach(panel => {
          panel.querySelectorAll('video').forEach(video => {
            if (panel.hidden) { video.pause(); return; }
            video.muted = true; video.playsInline = true;
            video.play()?.catch(() => {});
          });
          const template = panel.querySelector('template[data-external-media]');
          if (template) {
            if (panel.hidden) panel.querySelectorAll('iframe').forEach(frame => frame.remove());
            else if (!panel.querySelector('iframe')) {
              panel.append(template.content.cloneNode(true));
              const playButton = panel.querySelector('[data-play-external]');
              if (playButton) playButton.hidden = true;
            }
          }
        });
      };
      this.syncPlayback();
      this.addEventListener('click', event => {
        const play = event.target.closest('[data-play-external]');
        if (play) {
          const template = play.parentElement.querySelector('template');
          play.replaceWith(template.content.cloneNode(true));
          return;
        }
        const button = event.target.closest('[data-media-target]');
        if (!button) return;
        const target = document.getElementById(button.dataset.mediaTarget);
        if (!target || !this.contains(target)) return;
        this.querySelectorAll('.pd-media').forEach(panel => {
          panel.hidden = panel !== target;
          if (panel.hidden) {
            panel.querySelectorAll('video').forEach(video => video.pause());
            panel.querySelectorAll('iframe').forEach(frame => { frame.src = frame.src; });
            panel.querySelectorAll('model-viewer').forEach(model => model.pause?.());
          }
        });
        this.syncPlayback();
        this.querySelectorAll('[data-media-target]').forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb === button)));
      });
    }
    disconnectedCallback() { this.railObserver?.disconnect(); this.ready = false; }
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-variant-select]')) return;
    const url = new URL(event.target.dataset.productUrl, location.origin);
    url.searchParams.set('variant', event.target.value);
    location.assign(url.href);
  });
}

if (!customElements.get('studio-sticky-cart')) {
 customElements.define('studio-sticky-cart', class extends HTMLElement {
  connectedCallback() {
   this.mainForm = document.getElementById(this.dataset.mainForm);
   this.mainButton = this.mainForm?.querySelector('[name="add"]');
   this.scrolledDown = false;
   this.lastScrollY = window.scrollY;
   this.update = () => {
    const mobile = !this.classList.contains('pd-sticky-mobile') || matchMedia('(max-width:749px)').matches;
    const passedButton = this.mainButton && this.mainButton.getBoundingClientRect().bottom <= 0;
    const visible = mobile && this.scrolledDown && passedButton;
    this.hidden = !visible;
    document.body.style.setProperty('--sticky-space', visible ? `${this.offsetHeight}px` : '0px');
   };
   this.observer = new IntersectionObserver(this.update);
   this.onScroll = () => {
    if (window.scrollY > this.lastScrollY) this.scrolledDown = true;
    if (window.scrollY <= 0) this.scrolledDown = false;
    this.lastScrollY = window.scrollY;
    this.update();
   };
   window.addEventListener('scroll', this.onScroll, {passive:true});
   if (this.mainButton) this.observer.observe(this.mainButton);
   this.resize = new ResizeObserver(this.update); this.resize.observe(this);
   window.addEventListener('resize', this.update);
   this.bundleClickHandler = event => {
    if (!event.target.closest('[data-select-bundle]')) return;
    const product = this.closest('.product-top');
    const target = product?.querySelector('studio-quantity-bundle') || product?.querySelector('.pd-device') || this.mainForm;
    if (!target) return;
    const header = document.querySelector('.shopify-section-group-header-group');
    const offset = Math.max(80, header?.getBoundingClientRect().height || 0) + 20;
    const focusTarget = target.querySelector('input:checked:not(:disabled), input:not(:disabled), select, button');
    focusTarget?.focus({preventScroll:true});
    window.scrollTo({top:Math.max(0, window.scrollY + target.getBoundingClientRect().top - offset), behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth'});
   };
   this.addEventListener('click', this.bundleClickHandler);
   this.submitHandler = () => {const quantity = this.mainForm?.elements.namedItem('quantity'); if (quantity) this.querySelector('[name="quantity"]').value = quantity.value;};
   this.addEventListener('submit', this.submitHandler);
   this.update();
  }
  disconnectedCallback() {this.removeEventListener('click',this.bundleClickHandler);this.observer?.disconnect();this.resize?.disconnect();window.removeEventListener('resize',this.update);window.removeEventListener('scroll',this.onScroll);this.removeEventListener('submit',this.submitHandler);document.body.style.removeProperty('--sticky-space');}
 });
}


if (!customElements.get('studio-quantity-bundle')) customElements.define('studio-quantity-bundle', class extends HTMLElement {
 connectedCallback() {
  this.form = document.getElementById(this.dataset.form);
  if (!this.form || this.ready) return;
  this.ready = true;
  this.error = this.querySelector('[data-bundle-error]');
  this.mixed = !!this.querySelector('[data-bundle-variant]');
  this.money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:this.dataset.currency || 'USD'}).format(value / 100);
  this.cards = [...this.querySelectorAll('.pd-bundle-option')];
  if (this.mixed) this.cards.forEach(card => {
   card.querySelector('.pd-bundle-radio').disabled = ![...card.querySelectorAll('select option')].some(option => !option.disabled);
   card.querySelectorAll('select').forEach(select => { if (select.selectedOptions[0]?.disabled) select.value = [...select.options].find(option => !option.disabled)?.value || ''; });
  });
  if (!this.querySelector('.pd-bundle-radio:checked:not(:disabled)')) {
   const first = this.querySelector('.pd-bundle-radio:not(:disabled)');
   if (first) first.checked = true;
  }
  this.sync = () => {
   const selected = this.querySelector('.pd-bundle-radio:checked:not(:disabled)');
   this.cards.forEach(card => {
    const radio = card.querySelector('.pd-bundle-radio');
    const active = radio === selected;
    const panel = card.querySelector('[data-bundle-variants]');
    if (panel) { panel.hidden = !active; panel.disabled = !active; }
    if (!this.mixed) return;
    const options = [...card.querySelectorAll('select')].map(select => select.selectedOptions[0]).filter(Boolean);
    const sum = options.reduce((total, option) => total + Number(option.dataset.price), 0);
    const compare = options.reduce((total, option) => total + (card.dataset.compareSource === 'price' ? Number(option.dataset.price) : Math.max(Number(option.dataset.compare), Number(option.dataset.price))), 0);
    const total = Math.max(0, Math.round(sum * (100 - Number(card.dataset.percent)) / 100) - Number(card.dataset.fixed));
    const tokens = {'[price]':this.money(total),'[compare_price]':this.money(compare),'[amount_saved]':this.money(Math.max(0,compare-total)),'[quantity]':radio.value};
    const format = template => template.replace(/\[(price|compare_price|amount_saved|quantity)\]/g, token => tokens[token]);
    card.querySelector('.pd-bundle-price strong').textContent = format(card.dataset.priceTemplate || '[price]');
    const strike = card.querySelector('.pd-bundle-price s');
    if (strike) { strike.textContent = format(card.dataset.compareTemplate || '[compare_price]'); strike.hidden = compare <= total; }
    const caption = card.querySelector('.pd-bundle-copy > span');
    if (caption) caption.textContent = format(card.dataset.caption || '');
    radio.dataset.total = this.money(total);
   });
   const sticky = this.closest('.product-top')?.querySelector('studio-sticky-cart');
   if (sticky && selected) {
    const price = sticky.querySelector('[data-sticky-price]'); if (price) price.textContent = selected.dataset.total;
    const quantity = sticky.querySelector('[name="quantity"]'); if (quantity) quantity.value = selected.value;
   }
   [this.form,sticky].forEach(container => {const button=container?.querySelector('[name="add"]');if(button)button.disabled=this.busy || !selected;});
   this.error.hidden = true;
  };
  this.onSubmit = async event => {
   if (!this.mixed) return;
   event.preventDefault();
   event.stopImmediatePropagation();
   if (this.busy) return;
   const card = this.querySelector('.pd-bundle-radio:checked:not(:disabled)')?.closest('.pd-bundle-option');
   if (!card) return;
   const items = new Map();
   let valid = true;
   card.querySelectorAll('select').forEach(select => {
    const option = select.selectedOptions[0];
    if (!option || option.disabled) {valid=false;return;}
    const entry = items.get(select.value) || {id:select.value,quantity:0,option};
    entry.quantity++;items.set(select.value,entry);
   });
   for (const {quantity,option} of items.values()) {
    const {min,step,max} = option.dataset;
    if (quantity < Number(min || 1) || quantity % Number(step || 1) !== 0 || (max !== '' && quantity > Number(max))) valid=false;
   }
   if (!valid) {this.error.textContent=this.dataset.stockError;this.error.hidden=false;return;}
   this.busy=true;this.sync();this.form.setAttribute('aria-busy','true');
   try {
    const data = new FormData(this.form);
    const properties = {};
    for (const [name,value] of data) {const match=name.match(/^properties\[(.+)\]$/);if(match)properties[match[1]]=value;}
    const payload = [...items.values()].map(({id,quantity}) => ({id,quantity,...(Object.keys(properties).length?{properties}:{}),...(data.get('selling_plan')?{selling_plan:data.get('selling_plan')}:{})}));
    const response = await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:payload,sections:['cart-drawer'],sections_url:location.pathname})});
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || this.dataset.error);
    const drawer = document.querySelector('studio-cart');
    this.busy=false;this.sync();this.form.removeAttribute('aria-busy');
    if (drawer?.render && drawer?.open) {
     drawer.open(event.submitter);
     try { await drawer.render(result.sections?.['cart-drawer']); }
     catch { drawer.error(this.dataset.error); }
    } else { location.assign(this.dataset.cartUrl); }
   } catch (error) {
    this.busy=false;this.sync();this.form.removeAttribute('aria-busy');this.error.textContent=error.message || this.dataset.error;this.error.hidden=false;
   }
  };
  this.addEventListener('change',this.sync);
  this.form.addEventListener('submit',this.onSubmit);
  this.classList.add('pd-bundles-ready');this.sync();
 }
 disconnectedCallback() {this.removeEventListener('change',this.sync);this.form?.removeEventListener('submit',this.onSubmit);this.ready=false;}
});
